import React, { useEffect, useState } from "react";

// SideIndex — fixed, right-edge floating section index.
// Hairline vertical with current section indicator (a single filled dot).
const SECTIONS = [
  { id: "top", label: "00" },
  { id: "definition", label: "01" },
  { id: "whynow", label: "02" },
  { id: "longview", label: "03" },
  { id: "principles", label: "04" },
  { id: "practice", label: "05" },
  { id: "literature", label: "06" },
  { id: "reminder", label: "07" },
  { id: "transition", label: "08" },
  { id: "join", label: "09" },
];

export default function SideIndex() {
  const [active, setActive] = useState("top");

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY + window.innerHeight * 0.35;
      let current = "top";
      for (const s of SECTIONS) {
        const el = document.getElementById(s.id);
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY;
          if (top <= y) current = s.id;
        }
      }
      setActive(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      aria-label="section index"
      data-testid="side-index"
      className="side-index"
    >
      <ul>
        {SECTIONS.map((s) => (
          <li key={s.id} data-active={active === s.id}>
            <a href={`#${s.id}`} className="side-link" data-testid={`side-index-${s.label}`}>
              <span className="side-label">{s.label}</span>
              <span className="side-dot" aria-hidden="true" />
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
